import type { ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

type StatsCardProps = {
  title: ReactNode
  children?: ReactNode
  controls?: ReactNode
  /** Optional leading icon, rendered in an accent chip before the title. */
  icon?: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
}

export const StatsCard = ({ title, children, controls, icon, className, ref }: StatsCardProps) => {
  return (
    <Paper
      ref={ref}
      className={cn('flex flex-[1_0_auto] flex-col gap-4 rounded-md px-5 py-4', className)}
      elevation="2"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex min-w-0 items-center gap-2">
          {icon != null && (
            <span className="flex size-8 shrink-0 items-center justify-center rounded-sm bg-primary-states-focus [&_svg]:size-5 [&_svg]:text-primary-main">
              {icon}
            </span>
          )}
          <Typography
            className="font-semibold"
            variant="subtitle1"
          >
            {title}
          </Typography>
        </div>
        {controls}
      </div>
      <div>{children}</div>
    </Paper>
  )
}
